import DynamciLanding from './DynamicLanding';

export default DynamciLanding;
